import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/fonts/pluss60-icons/pluss60IconStyles.css';
import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
